import { FC } from 'react';
import { MainButton } from '../MainButton';
import { styled } from '@mui/material';
import { ButtonName, ESendLinkModal } from '../../constants';

const StyledButton = styled(MainButton)(({ theme }) => ({
  margin: theme.spacing(2, 0, 1, 0),
}));

type RefreshButtonProps = { onRefresh: () => void };

export const RefreshButton: FC<RefreshButtonProps> = ({ onRefresh }) => {
  return (
    <StyledButton
      data-testid="link-refresh-button"
      buttonName={ButtonName.RefreshQrCode}
      variant="contained"
      fullWidth
      onClick={onRefresh}
    >
      {ESendLinkModal.Refresh}
    </StyledButton>
  );
};
